import AbstractUIScreen from "../screen/AbstractUIScreen";
import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import IApp from "../../engine/IApp";
import IUIMessages from "../messages/IUIMessages";

export default class DesktopUIScreen extends AbstractUIScreen {

    protected containerPaddingTop: number = 50;
    protected containerPaddingBottom: number = 120;
    protected containerPaddingLeft: number = 10;
    protected containerPaddingRight: number = 10;

    uiType: string = "default";

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: IUIMessages
    ) {
        super(config, app, uiMessages);
    }


}